import type { NextAction, WorkflowRun } from './workflows.types.js';

export const AI_INSIGHTS = 'aiInsights';
// ponytail: AI Insights is hidden from the UI for now; flip to false to bring the chip back.
export const AI_INSIGHTS_HIDDEN = true;

// Only the service decides where AI Insights is offered: its edge, enabled, is the offer.
export function insightsEdge(run: WorkflowRun): NextAction | null {
  const edge = run.nextActions.find((action) => action.actionType === AI_INSIGHTS);
  return edge?.enabled ? edge : null;
}
